const GET_FLEET_ASSET_CHANGE_LOG = "GET_FLEET_ASSET_CHANGE_LOG"
const SET_FLEET_ASSET_CHANGE_LOG = "SET_FLEET_ASSET_CHANGE_LOG"
const GET_FLEET_AFE_CHANGE_LOG = "GET_FLEET_AFE_CHANGE_LOG"
const SET_FLEET_AFE_CHANGE_LOG = "SET_FLEET_AFE_CHANGE_LOG"

export {
    GET_FLEET_ASSET_CHANGE_LOG,
    SET_FLEET_ASSET_CHANGE_LOG,
    GET_FLEET_AFE_CHANGE_LOG,
    SET_FLEET_AFE_CHANGE_LOG
}